import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import '../../Login.css'; // stil separat

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError('Autentificare eșuată. Verifică datele introduse.');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="login-container d-flex justify-content-center align-items-center">
      <div className="login-card shadow p-4 rounded">
        <div className="text-center mb-4">
          <div className="logo-text">JOINSTACK</div>
          <h4>Autentificare</h4>
        </div>
        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-control mb-3 input-smooth"
          />

          <label>Parolă</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="form-control mb-3 input-smooth"
          />

          {error && <p className="text-danger small">{error}</p>}

          <button type="submit" className="btn btn-primary w-100">
            Conectează-te
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
